// @ts-expect-error
import type {DataProxy, FetchResult} from 'react-apollo';

import type {
    GetSendableEmails as GetSendableEmailsQuery,
    setGoogleMailSendIsEnabled as setGoogleMailSendIsEnabledMutation,
    setOffice365MailSendIsEnabled as setOffice365MailSendIsEnabledMutation,
} from 'nutshell-graphql-types';

import {getEmailAddresses} from '../../integrations/integration-mutation-response-helpers';

import GET_SENDABLE_EMAILS_QUERY from '../graphql/queries/get-sendable-emails.graphql';

type MutationResult =
    | FetchResult<setGoogleMailSendIsEnabledMutation>
    | FetchResult<setOffice365MailSendIsEnabledMutation>;

export function updateCacheFromMutation(proxy: DataProxy, mutationResult: MutationResult) {
    const emailAddresses = getEmailAddresses(mutationResult);
    if (emailAddresses) {
        const cacheResult: GetSendableEmailsQuery | null | undefined = proxy.readQuery({
            query: GET_SENDABLE_EMAILS_QUERY,
        });

        if (cacheResult) {
            proxy.writeQuery({
                query: GET_SENDABLE_EMAILS_QUERY,
                data: {
                    loggedInUser: {
                        ...cacheResult.loggedInUser,
                        emailAddresses: emailAddresses,
                    },
                },
            });
        }

        // Update client config. If we have enabled emails, then the user has
        // configured email. This is approximating the `hasConfiguredEmail`
        // method on the user model on the backend, where email is configured if
        // there is at least a single email address the user can sync or send
        // from.
        const numberOfEnabledEmails = emailAddresses.filter((emailAddress) => {
            return emailAddress.isEnabledForSending || emailAddress.isSyncEnabled;
        }).length;

        NutClientConfig.hasConfiguredEmail = numberOfEnabledEmails > 0;
    } else {
        NutClientConfig.hasConfiguredEmail = false;
    }
}
